/**
 * Sync device-class hint for routing/layout. Not the same as viewport width.
 */
export function isMobileUserAgent(): boolean {
  if (typeof navigator === "undefined") {
    return false;
  }

  const uaData = (navigator as Navigator & { userAgentData?: { mobile?: boolean } }).userAgentData;
  if (uaData && typeof uaData.mobile === "boolean") {
    return uaData.mobile;
  }

  return /Mobi|Android|iPhone|iPad|iPod|Tablet|Silk|Kindle|BlackBerry|Opera Mini|IEMobile|WPDesktop/i.test(
    navigator.userAgent,
  );
}
